// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37R0k","col":"styles_col__2pwpd","actions":"styles_actions__1n0O7","conflict":"styles_conflict__33mWS"};